export interface Category {
  name: string;
  url: string;
  seq: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    seq: "cat-shoes",
    description: "Trending sneakers, boots & formal shoes",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    seq: "cat-hoodies",
    description: "Cozy hoodies & knit sweaters",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    seq: "cat-tshirts",
    description: "Graphic tees & essential basics",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    seq: "cat-jackets",
    description: "Bombers, denim & winter coats",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    seq: "cat-pants",
    description: "Cargo pants, jeans & summer shorts",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    seq: "cat-headwear",
    description: "Caps, beanies & bucket hats",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    seq: "cat-sets",
    description: "Coordinated outfit sets & bundles",
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    seq: "cat-underwear",
    description: "Comfortable everyday essentials",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    seq: "cat-jersey",
    description: "Sports jerseys & athletic wear",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    seq: "cat-accessories",
    description: "Watches, jewelry & eyewear",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    seq: "cat-bags",
    description: "Backpacks, totes & crossbody bags",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    seq: "cat-belts",
    description: "Leather belts & statement buckles",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    seq: "cat-perfumes",
    description: "Premium fragrances & colognes",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    seq: "cat-other",
    description: "Unique finds & miscellaneous items",
  },
];